import { Box, Container, Grid, Paper, Stack, Typography } from "@mui/material";
import React from "react";
import logo from "../../assets/svg/logo-white.svg";
import packageJson from "../../../package.json";

interface Props {
  children: React.ReactNode;
}

const LayoutAuth = ({ children }: Props) => {
  return (
    <Stack
      sx={(theme) => ({
        py: 2,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        width: 1,
        minHeight: "100vh",
        backgroundImage: `linear-gradient(50deg, ${theme.palette.primary.light} 1%, ${theme.palette.primary.dark} 83%)`,
      })}
    >
      <Container>
        <Grid container alignItems="center">
          <Grid item md={7} sx={{ display: "flex", justifyContent: "center" }}>
            <Box component="img" src={logo} alt="Logo" height={100} />
          </Grid>
          <Grid item md={5}>
            <Stack spacing={1}>
              <Paper elevation={10} sx={{ p: 8 }}>
                {children}
              </Paper>
              <Typography
                color="white"
                sx={{ alignSelf: "center" }}
                variant="caption"
              >
                BovPilot v{packageJson.version ?? "0.0.0"}
              </Typography>
            </Stack>
          </Grid>
        </Grid>
      </Container>
    </Stack>
  );
};

export { LayoutAuth };
